/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import GalaxyBasic from 'astro/fake/galaxy.basic';

import SpaceshipEnum from 'astro/enum/spaceship';
import BuildingEnum from 'astro/enum/building';
import UnitEnum from 'astro/enum/unit';

import InteractionEnum from 'astro/enum/interaction';
import ProjectileEnum from 'astro/enum/projectile';
import ShapeEnum from 'shared/enum/shape';

import * as Influence from 'astro/value/influence';


export default () =>
{
  const galaxy = GalaxyBasic();

  setupPlanetOne(galaxy);
  setupPlanetTwo(galaxy);
  setupPlanetThree(galaxy);
  setupPlanetFour(galaxy);
  setupPlanetFive(galaxy);

  setupInterplanetaryInteractions(galaxy);

  galaxy.finalize();

  return galaxy;
}


const setupPlanetOne = (galaxy) =>
{
  const planet = galaxy.getPlanet(0);

  // 1
  planet.getSector(0).assignUser(galaxy.getUser(1));
  planet.getSector(1).assignUser(galaxy.getUser(1));
  planet.getSector(4).assignUser(galaxy.getUser(2));
  planet.getSector(7).assignUser(galaxy.getUser(2));

  // 2
  planet.getSector(2).assignUser(galaxy.getUser(1));

  // 3
  planet.getSector(5).assignUser(galaxy.getUser(1));
  planet.getSector(8).assignUser(galaxy.getUser(1));
  planet.getSector(3).assignUser(galaxy.getUser(2));
  planet.getSector(6).assignUser(galaxy.getUser(2));

  // 4
  planet.getSector(5).assignUser(galaxy.getUser(2));

  // Energy
  planet.getZone(1, 0).assignEnergy([ [ galaxy.getUser(1),100 ] ]);
  planet.getZone(2, 0).assignEnergy([ [ galaxy.getUser(1),100 ] ]);
  planet.getZone(1, 1).assignEnergy([ [ galaxy.getUser(1), 82 ] ]);
  planet.getZone(2, 1).assignEnergy([ [ galaxy.getUser(1),100 ] ]);
  planet.getZone(1, 2).assignEnergy([ [ galaxy.getUser(1), 95 ] ]);
  planet.getZone(2, 2).assignEnergy([ [ galaxy.getUser(1), 85 ] ]);
  planet.getZone(1, 3).assignEnergy([ [ galaxy.getUser(1), 75 ] ]);
  planet.getZone(2, 3).assignEnergy([ [ galaxy.getUser(1), 93 ] ]);
  planet.getZone(3, 3).assignEnergy([ [ galaxy.getUser(1), 75 ] ]);

  planet.getZone(4, 2).assignEnergy([ [ galaxy.getUser(1), 76 ] ]);
  planet.getZone(3, 2).assignEnergy([ [ galaxy.getUser(1), 77 ] ]);
  planet.getZone(5, 1).assignEnergy([ [ galaxy.getUser(1), 85 ] ]);
  planet.getZone(4, 1).assignEnergy([ [ galaxy.getUser(1), 75 ] ]);
  planet.getZone(3, 0).assignEnergy([ [ galaxy.getUser(1), 72 ] ]);
  planet.getZone(3, 1).assignEnergy([ [ galaxy.getUser(1), 71 ] ]);
  planet.getZone(4, 0).assignEnergy([ [ galaxy.getUser(1), 80 ] ]);

  planet.getZone(0, 4).assignEnergy([ [ galaxy.getUser(1), 35 ] ]);
  planet.getZone(1, 4).assignEnergy([ [ galaxy.getUser(1), 60 ] ]);
  planet.getZone(2, 4).assignEnergy([ [ galaxy.getUser(1), 68 ] ]);
  planet.getZone(1, 5).assignEnergy([ [ galaxy.getUser(1), 53 ] ]);
  planet.getZone(0, 6).assignEnergy([ [ galaxy.getUser(1), 72 ] ]);
  planet.getZone(1, 6).assignEnergy([ [ galaxy.getUser(1), 62 ] ]);
  planet.getZone(0, 5).assignEnergy([ [ galaxy.getUser(1), 38 ] ]);
  planet.getZone(2, 5).assignEnergy([ [ galaxy.getUser(1), 55 ] ]);
  planet.getZone(3, 5).assignEnergy([ [ galaxy.getUser(1), 68 ] ]);

  planet.getZone(1, 7).assignEnergy([ [ galaxy.getUser(2), 37 ], [ galaxy.getUser(1), 28 ] ]);
  planet.getZone(2, 7).assignEnergy([ [ galaxy.getUser(2), 40 ], [ galaxy.getUser(1), 25 ] ]);
  planet.getZone(2, 8).assignEnergy([ [ galaxy.getUser(2), 27 ], [ galaxy.getUser(1),  5 ] ]);
  planet.getZone(1, 8).assignEnergy([ [ galaxy.getUser(2), 40 ], [ galaxy.getUser(1), 22 ] ]);
  planet.getZone(0, 8).assignEnergy([ [ galaxy.getUser(2), 22 ], [ galaxy.getUser(1), 36 ] ]);
  planet.getZone(1, 9).assignEnergy([ [ galaxy.getUser(2), 25 ], [ galaxy.getUser(1), 30 ] ]);
  planet.getZone(2, 9).assignEnergy([ [ galaxy.getUser(2), 36 ], [ galaxy.getUser(1), 20 ] ]);
  planet.getZone(2, 6).assignEnergy([ [ galaxy.getUser(2), 43 ] ]);
  planet.getZone(3, 7).assignEnergy([ [ galaxy.getUser(2), 38 ] ]);

  planet.getZone(2,11).assignEnergy([ [ galaxy.getUser(1), 46 ], [ galaxy.getUser(2), 30 ] ]);
  planet.getZone(1,11).assignEnergy([ [ galaxy.getUser(1), 40 ], [ galaxy.getUser(2), 30 ] ]);
  planet.getZone(1,10).assignEnergy([ [ galaxy.getUser(1), 41 ], [ galaxy.getUser(2), 30 ] ]);
  planet.getZone(0,10).assignEnergy([ [ galaxy.getUser(1), 43 ], [ galaxy.getUser(2), 30 ] ]);
  planet.getZone(0,12).assignEnergy([ [ galaxy.getUser(1),  0 ], [ galaxy.getUser(2), 30 ] ]);
  planet.getZone(1,12).assignEnergy([ [ galaxy.getUser(1),  0 ], [ galaxy.getUser(2), 30 ] ]);
  planet.getZone(2,10).assignEnergy([ [ galaxy.getUser(1), 32 ] ]);

  planet.getZone(3, 4).assignEnergy([ [ galaxy.getUser(2), 64 ] ]);
  planet.getZone(5, 5).assignEnergy([ [ galaxy.getUser(2), 64 ] ]);
  planet.getZone(5, 4).assignEnergy([ [ galaxy.getUser(2), 76 ] ]);
  planet.getZone(5, 3).assignEnergy([ [ galaxy.getUser(2), 72 ] ]);
  planet.getZone(3, 6).assignEnergy([ [ galaxy.getUser(2), 61 ] ]);
  planet.getZone(4, 6).assignEnergy([ [ galaxy.getUser(2), 64 ] ]);
  planet.getZone(4, 5).assignEnergy([ [ galaxy.getUser(2), 70 ] ]);
  planet.getZone(4, 4).assignEnergy([ [ galaxy.getUser(2), 68 ] ]);
  planet.getZone(4, 3).assignEnergy([ [ galaxy.getUser(2), 69 ] ]);

  planet.getZone(7, 4).assignEnergy([ [ galaxy.getUser(2), 90 ] ]);
  planet.getZone(7, 3).assignEnergy([ [ galaxy.getUser(2), 85 ] ]);
  planet.getZone(6, 3).assignEnergy([ [ galaxy.getUser(2), 80 ] ]);
  planet.getZone(8, 3).assignEnergy([ [ galaxy.getUser(2), 91 ] ]);
  planet.getZone(7, 2).assignEnergy([ [ galaxy.getUser(2),100 ] ]);
  planet.getZone(6, 2).assignEnergy([ [ galaxy.getUser(2), 90 ] ]);
  planet.getZone(5, 2).assignEnergy([ [ galaxy.getUser(2), 90 ] ]);
  planet.getZone(6, 1).assignEnergy([ [ galaxy.getUser(2),100 ] ]);
  planet.getZone(7, 1).assignEnergy([ [ galaxy.getUser(2),100 ] ]);

  planet.getZone(5, 7).assignEnergy([ [ galaxy.getUser(2), 82 ] ]);
  planet.getZone(6, 7).assignEnergy([ [ galaxy.getUser(2), 69 ] ]);
  planet.getZone(5, 6).assignEnergy([ [ galaxy.getUser(2), 72 ] ]);
  planet.getZone(6, 6).assignEnergy([ [ galaxy.getUser(2), 74 ] ]);
  planet.getZone(6, 5).assignEnergy([ [ galaxy.getUser(2), 82 ] ]);
  planet.getZone(7, 5).assignEnergy([ [ galaxy.getUser(2), 85 ] ]);
  planet.getZone(6, 4).assignEnergy([ [ galaxy.getUser(2), 92 ] ]);

  planet.getZone(3, 9).assignEnergy([ [ galaxy.getUser(2), 88 ] ]);
  planet.getZone(4, 9).assignEnergy([ [ galaxy.getUser(2), 88 ] ]);
  planet.getZone(3,10).assignEnergy([ [ galaxy.getUser(2), 92 ] ]);
  planet.getZone(4,10).assignEnergy([ [ galaxy.getUser(2), 77 ] ]);
  planet.getZone(3, 8).assignEnergy([ [ galaxy.getUser(2), 77 ] ]);
  planet.getZone(4, 8).assignEnergy([ [ galaxy.getUser(2), 88 ] ]);
  planet.getZone(4, 7).assignEnergy([ [ galaxy.getUser(2), 81 ] ]);
  planet.getZone(5, 8).assignEnergy([ [ galaxy.getUser(2), 80 ] ]);
  planet.getZone(5, 9).assignEnergy([ [ galaxy.getUser(2), 67 ] ]);

  // Buildings
  planet.createBuilding([ 1, 2 ], BuildingEnum.TransferStation);
  planet.createBuilding([ 3, 1 ], BuildingEnum.Outpost).setStatus('upgrade');
  planet.createBuilding([ 0, 4 ], BuildingEnum.Spaceport);
  planet.createBuilding([ 0,10 ], BuildingEnum.Spaceport);

  planet.createBuilding([ 1, 8 ], BuildingEnum.Outpost);
  planet.createBuilding([ 6, 2 ], BuildingEnum.DistributionCenter);
  planet.createBuilding([ 6, 5 ], BuildingEnum.GaussArtillery);
  planet.createBuilding([ 4, 9 ], BuildingEnum.GaussArtillery);
  planet.createBuilding([ 4, 4 ], BuildingEnum.Outpost);

  // Units
  planet.createUnit([ 1, 7 ], UnitEnum.AreaAttack).setStatus('attack');
  planet.createUnit([ 3, 8 ], UnitEnum.AreaAttack).setStatus('attack');
  planet.createUnit([ 4,10 ], UnitEnum.AreaAttack).setStatus('attack');
  planet.createUnit([ 5, 9 ], UnitEnum.AreaAttack).setStatus('attack');

  // Spaceships
  galaxy.createSpaceship([ -3,  0 ], SpaceshipEnum.FighterBasic, galaxy.getUser(1)).setStatus('dock');
  galaxy.createSpaceship([ -4,  1 ], SpaceshipEnum.FighterBasic, galaxy.getUser(1)).setStatus('dock');

  // Interactions
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 1, 7), planet.getZone( 1,11), { type: ShapeEnum.SextupleArea, variant: 5 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 3, 8), planet.getZone( 1,11), { type: ShapeEnum.SextupleArea, variant: 5 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 4,10), planet.getZone( 1,11), { type: ShapeEnum.SextupleArea, variant: 5 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 5, 9), planet.getZone( 1,11), { type: ShapeEnum.SextupleArea, variant: 5 }, { value: Influence.fromPercentage(6)});

  //galaxy.createTransferInteraction(planet.getZone( 1, 2), planet.getZone( 0, 4), { type: ShapeEnum.Sector, variant: 0 });

  // Projectiles
  galaxy.createProjectile(ProjectileEnum.LaserBattery, planet.getZone( 6, 5), planet.getZone( 4, 1), { type: ShapeEnum.SeptupleArea, variant: 0 }, 700, 900);
  galaxy.createProjectile(ProjectileEnum.LaserBattery, planet.getZone( 4, 9), planet.getZone( 4, 1), { type: ShapeEnum.SeptupleArea, variant: 0 }, 450, 900);

}


const setupPlanetTwo = (galaxy) =>
{
  const planet = galaxy.getPlanet(1);

  // 1
  planet.getSector(2).assignUser(galaxy.getUser(3));
  planet.getSector(8).assignUser(galaxy.getUser(3));

  // 2
  planet.getSector(5).assignUser(galaxy.getUser(3));

  // 3
  planet.getSector(9).assignUser(galaxy.getUser(3));
  planet.getSector(10).assignUser(galaxy.getUser(3));

  // 4
  planet.getSector(4).assignUser(galaxy.getUser(1));

  // Energy
  planet.getZone( 7, 1).assignEnergy([ [ galaxy.getUser(3), 85 ] ]);
  planet.getZone( 8, 3).assignEnergy([ [ galaxy.getUser(3), 82 ] ]);
  planet.getZone( 9, 2).assignEnergy([ [ galaxy.getUser(3), 76 ] ]);
  planet.getZone( 8, 2).assignEnergy([ [ galaxy.getUser(3), 84 ] ]);
  planet.getZone( 9, 3).assignEnergy([ [ galaxy.getUser(3), 85 ] ]);
  planet.getZone( 9, 4).assignEnergy([ [ galaxy.getUser(3), 91 ] ]);
  planet.getZone(10, 2).assignEnergy([ [ galaxy.getUser(3), 75 ] ]);
  planet.getZone( 9, 1).assignEnergy([ [ galaxy.getUser(3), 80 ] ]);
  planet.getZone( 8, 1).assignEnergy([ [ galaxy.getUser(3), 60 ] ]);

  planet.getZone(10, 4).assignEnergy([ [ galaxy.getUser(3),100 ] ]);
  planet.getZone(10, 5).assignEnergy([ [ galaxy.getUser(3),100 ] ]);
  planet.getZone( 9, 5).assignEnergy([ [ galaxy.getUser(3),100 ] ]);
  planet.getZone(11, 4).assignEnergy([ [ galaxy.getUser(3),100 ] ]);
  planet.getZone(10, 3).assignEnergy([ [ galaxy.getUser(3),100 ] ]);
  planet.getZone(10, 6).assignEnergy([ [ galaxy.getUser(3),100 ] ]);
  planet.getZone(11, 5).assignEnergy([ [ galaxy.getUser(3),100 ] ]);
  planet.getZone(11, 6).assignEnergy([ [ galaxy.getUser(3),100 ] ]);
  planet.getZone(12, 6).assignEnergy([ [ galaxy.getUser(3),100 ] ]);

  planet.getZone( 8, 4).assignEnergy([ [ galaxy.getUser(3), 87 ] ]);
  planet.getZone( 7, 3).assignEnergy([ [ galaxy.getUser(3), 90 ] ]);
  planet.getZone( 6, 4).assignEnergy([ [ galaxy.getUser(3), 67 ] ]);
  planet.getZone( 6, 5).assignEnergy([ [ galaxy.getUser(3), 70 ] ]);
  planet.getZone( 7, 4).assignEnergy([ [ galaxy.getUser(3), 75 ] ]);
  planet.getZone( 7, 5).assignEnergy([ [ galaxy.getUser(3), 49 ] ]);
  planet.getZone( 8, 5).assignEnergy([ [ galaxy.getUser(3), 50 ] ]);

  planet.getZone(11, 2).assignEnergy([ [ galaxy.getUser(3), 95 ] ]);
  planet.getZone(11, 3).assignEnergy([ [ galaxy.getUser(3), 98 ] ]);
  planet.getZone(10, 1).assignEnergy([ [ galaxy.getUser(3), 90 ] ]);
  planet.getZone(12, 4).assignEnergy([ [ galaxy.getUser(3), 85 ] ]);
  planet.getZone(12, 2).assignEnergy([ [ galaxy.getUser(3), 75 ] ]);
  planet.getZone(12, 3).assignEnergy([ [ galaxy.getUser(3), 56 ] ]);
  planet.getZone(12, 1).assignEnergy([ [ galaxy.getUser(3), 52 ] ]);
  planet.getZone(13, 2).assignEnergy([ [ galaxy.getUser(3), 45 ] ]);
  planet.getZone(11, 1).assignEnergy([ [ galaxy.getUser(3), 40 ] ]);

  planet.getZone( 5, 3).assignEnergy([ [ galaxy.getUser(0), 40 ], [ galaxy.getUser(3), 60 ] ]);
  planet.getZone( 6, 3).assignEnergy([ [ galaxy.getUser(0), 35 ], [ galaxy.getUser(3), 65 ] ]);
  planet.getZone( 7, 2).assignEnergy([ [ galaxy.getUser(0), 38 ], [ galaxy.getUser(3), 62 ] ]);
  planet.getZone( 6, 1).assignEnergy([ [ galaxy.getUser(0), 39 ], [ galaxy.getUser(3), 61 ] ]);
  planet.getZone( 6, 2).assignEnergy([ [ galaxy.getUser(0), 55 ], [ galaxy.getUser(3), 45 ] ]);
  planet.getZone( 5, 2).assignEnergy([ [ galaxy.getUser(0), 55 ], [ galaxy.getUser(3), 45 ] ]);
  planet.getZone( 5, 1).assignEnergy([ [ galaxy.getUser(0), 65 ], [ galaxy.getUser(3), 35 ] ]);

  planet.getZone(5, 6).assignEnergy([ [ galaxy.getUser(1), 75 ] ]);
  planet.getZone(4, 6).assignEnergy([ [ galaxy.getUser(1), 53 ] ]);
  planet.getZone(4, 5).assignEnergy([ [ galaxy.getUser(1), 55 ] ]);
  planet.getZone(3, 5).assignEnergy([ [ galaxy.getUser(1), 45 ] ]);
  planet.getZone(3, 6).assignEnergy([ [ galaxy.getUser(1), 25 ] ]);
  planet.getZone(5, 7).assignEnergy([ [ galaxy.getUser(1), 70 ] ]);
  planet.getZone(5, 7).assignEnergy([ [ galaxy.getUser(1), 70 ] ]);
  planet.getZone(4, 4).assignEnergy([ [ galaxy.getUser(1), 10 ] ]);
  planet.getZone(5, 5).assignEnergy([ [ galaxy.getUser(1), 10 ] ]);
  planet.getZone(6, 6).assignEnergy([ [ galaxy.getUser(1), 10 ] ]);
  planet.getZone(4, 7).assignEnergy([ [ galaxy.getUser(1), 10 ] ]);
  planet.getZone(3, 7).assignEnergy([ [ galaxy.getUser(1), 30 ] ]);

  planet.getZone(13, 6).assignEnergy([ [ galaxy.getUser(3), 50 ] ]);
  planet.getZone(14, 6).assignEnergy([ [ galaxy.getUser(3), 35 ] ]);
  planet.getZone(13, 5).assignEnergy([ [ galaxy.getUser(3), 69 ] ]);
  planet.getZone(13, 3).assignEnergy([ [ galaxy.getUser(3), 56 ] ]);
  planet.getZone(13, 4).assignEnergy([ [ galaxy.getUser(3), 56 ] ]);
  planet.getZone(12, 5).assignEnergy([ [ galaxy.getUser(3), 56 ] ]);
  planet.getZone(14, 4).assignEnergy([ [ galaxy.getUser(3), 75 ] ]);
  planet.getZone(14, 5).assignEnergy([ [ galaxy.getUser(3), 73 ] ]);
  planet.getZone(13, 7).assignEnergy([ [ galaxy.getUser(3), 35 ] ]);

  planet.getZone( 2, 6).assignEnergy([ [ galaxy.getUser(0), 74 ], [ galaxy.getUser(1), 26 ] ]);
  planet.getZone( 2, 7).assignEnergy([ [ galaxy.getUser(0), 74 ], [ galaxy.getUser(1), 26 ] ]);
  planet.getZone( 2, 8).assignEnergy([ [ galaxy.getUser(0), 52 ], [ galaxy.getUser(1), 48 ] ]);
  planet.getZone( 1, 8).assignEnergy([ [ galaxy.getUser(0), 38 ], [ galaxy.getUser(1), 62 ] ]);

  // Buildings
  planet.createBuilding([ 9, 3 ], BuildingEnum.DistributionCenter);
  planet.createBuilding([ 9, 5 ], BuildingEnum.LaserBattery);
  planet.createBuilding([ 7, 4 ], BuildingEnum.TransferStation);
  planet.createBuilding([12, 2 ], BuildingEnum.GaussCannon);
  planet.createBuilding([13, 7 ], BuildingEnum.Spaceport);

  planet.createBuilding([ 4, 6 ], BuildingEnum.Outpost);

  // Units
  planet.createUnit([ 3, 6 ], UnitEnum.BasicAttack).setStatus('attack');
  planet.createUnit([ 6, 4 ], UnitEnum.BasicAttack).setStatus('attack');
  planet.createUnit([ 7, 1 ], UnitEnum.BasicAttack).setStatus('attack');
  planet.createUnit([ 9, 2 ], UnitEnum.RangeAttack).setStatus('attack');
  planet.createUnit([10, 2 ], UnitEnum.RangeAttack).setStatus('attack');

  // Spaceships
  galaxy.createSpaceship([ 2, -5 ], SpaceshipEnum.FighterBasic, galaxy.getUser(3)).setStatus('create');

  // Interactions
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 3, 6), planet.getZone( 2, 6), { type: ShapeEnum.DoubleBasic, variant: 1 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 7, 1), planet.getZone( 6, 1), { type: ShapeEnum.DoubleBasic, variant: 1 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 6, 4), planet.getZone( 5, 3), { type: ShapeEnum.DoubleBasic, variant: 0 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 9, 2), planet.getZone( 6, 2), { type: ShapeEnum.TripleArea, variant: 2 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone(10, 2), planet.getZone( 6, 2), { type: ShapeEnum.TripleArea, variant: 2 }, { value: Influence.fromPercentage(6)});

  //galaxy.createTransferInteraction(planet.getZone( 9, 5), planet.getZone(13, 7), { type: ShapeEnum.Sector, variant: 0 });
  //galaxy.createTransferInteraction(planet.getZone( 9, 5), planet.getZone( 8, 5), { type: ShapeEnum.Sector, variant: 0 });
}


const setupPlanetThree = (galaxy) =>
{
  const planet = galaxy.getPlanet(2);

  // 2
  planet.getSector(2).assignUser(galaxy.getUser(4));
  planet.getSector(3).assignUser(galaxy.getUser(4));

  // 3
  planet.getSector(6).assignUser(galaxy.getUser(4));

  // 4
  planet.getSector(5).assignUser(galaxy.getUser(4));
  planet.getSector(8).assignUser(galaxy.getUser(4));

  // Energy
  planet.getZone( 9, 5).assignEnergy([ [ galaxy.getUser(4), 80 ] ]);
  planet.getZone( 8, 5).assignEnergy([ [ galaxy.getUser(4), 90 ] ]);
  planet.getZone( 9, 4).assignEnergy([ [ galaxy.getUser(4), 90 ] ]);
  planet.getZone(10, 4).assignEnergy([ [ galaxy.getUser(4), 90 ] ]);

  planet.getZone( 8, 6).assignEnergy([ [ galaxy.getUser(4), 86 ] ]);
  planet.getZone( 7, 5).assignEnergy([ [ galaxy.getUser(4), 93 ] ]);
  planet.getZone( 7, 6).assignEnergy([ [ galaxy.getUser(4), 93 ] ]);
  planet.getZone( 7, 7).assignEnergy([ [ galaxy.getUser(4), 93 ] ]);
  planet.getZone( 8, 7).assignEnergy([ [ galaxy.getUser(4), 93 ] ]);
  planet.getZone( 9, 6).assignEnergy([ [ galaxy.getUser(4), 93 ] ]);

  planet.getZone( 5, 6).assignEnergy([ [ galaxy.getUser(4), 73 ] ]);
  planet.getZone( 6, 6).assignEnergy([ [ galaxy.getUser(4), 73 ] ]);
  planet.getZone( 4, 7).assignEnergy([ [ galaxy.getUser(4), 73 ] ]);
  planet.getZone( 5, 7).assignEnergy([ [ galaxy.getUser(4), 73 ] ]);
  planet.getZone( 6, 7).assignEnergy([ [ galaxy.getUser(4), 73 ] ]);
  planet.getZone( 5, 8).assignEnergy([ [ galaxy.getUser(4), 73 ] ]);
  planet.getZone( 6, 8).assignEnergy([ [ galaxy.getUser(4), 73 ] ]);

  planet.getZone( 5, 9).assignEnergy([ [ galaxy.getUser(4), 65 ] ]);
  planet.getZone( 6, 9).assignEnergy([ [ galaxy.getUser(4), 65 ] ]);
  planet.getZone( 6,10).assignEnergy([ [ galaxy.getUser(4), 65 ] ]);
  planet.getZone( 7,10).assignEnergy([ [ galaxy.getUser(4), 65 ] ]);
  planet.getZone( 4, 9).assignEnergy([ [ galaxy.getUser(4), 45 ] ]);
  planet.getZone( 4,10).assignEnergy([ [ galaxy.getUser(4), 45 ] ]);
  planet.getZone( 5,10).assignEnergy([ [ galaxy.getUser(4), 45 ] ]);
  planet.getZone( 5,11).assignEnergy([ [ galaxy.getUser(4), 30 ] ]);
  planet.getZone( 6,11).assignEnergy([ [ galaxy.getUser(4), 30 ] ]);

  planet.getZone( 5, 3).assignEnergy([ [ galaxy.getUser(0), 85 ], [ galaxy.getUser(4), 15 ] ]);
  planet.getZone( 6, 3).assignEnergy([ [ galaxy.getUser(0), 85 ], [ galaxy.getUser(4), 15 ] ]);
  planet.getZone( 5, 4).assignEnergy([ [ galaxy.getUser(0), 85 ], [ galaxy.getUser(4), 15 ] ]);
  planet.getZone( 6, 4).assignEnergy([ [ galaxy.getUser(0), 85 ], [ galaxy.getUser(4), 15 ] ]);
  planet.getZone( 7, 4).assignEnergy([ [ galaxy.getUser(0), 85 ], [ galaxy.getUser(4), 15 ] ]);
  planet.getZone( 5, 5).assignEnergy([ [ galaxy.getUser(0), 85 ], [ galaxy.getUser(4), 15 ] ]);
  planet.getZone( 6, 5).assignEnergy([ [ galaxy.getUser(0), 85 ], [ galaxy.getUser(4), 15 ] ]);

  // Buildings
  planet.createBuilding([ 9, 4 ], BuildingEnum.DistributionCenter);
  planet.createBuilding([11, 6 ], BuildingEnum.DistributionCenter);
  planet.createBuilding([ 5, 9 ], BuildingEnum.DistributionCenter).setStatus('create');
  planet.createBuilding([ 7, 9 ], BuildingEnum.Spaceport);

  // Units
  planet.createUnit([ 8, 6 ], UnitEnum.AreaAttack).setStatus('attack');
  planet.createUnit([ 9, 5 ], UnitEnum.AreaAttack).setStatus('attack');

  // Spaceships
  galaxy.createSpaceship([15, 5 ], SpaceshipEnum.FighterBasic, galaxy.getUser(4)).setStatus('dock');

  // Interactions
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 8, 6), planet.getZone( 6, 4), { type: ShapeEnum.SeptupleArea, variant: 0 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, planet.getZone( 9, 5), planet.getZone( 6, 4), { type: ShapeEnum.SeptupleArea, variant: 0 }, { value: Influence.fromPercentage(6)});
}


const setupPlanetFour = (galaxy) =>
{
  const planet = galaxy.getPlanet(3);

  // 1
  planet.getSector(0).assignUser(galaxy.getUser(5));
  planet.getSector(1).assignUser(galaxy.getUser(5));

  // 2
  planet.getSector(2).assignUser(galaxy.getUser(5));
  planet.getSector(3).assignUser(galaxy.getUser(5));

  // 3
  planet.getSector(4).assignUser(galaxy.getUser(5));
  planet.getSector(5).assignUser(galaxy.getUser(5));

  // 4
  planet.getSector(8).assignUser(galaxy.getUser(5));
  planet.getSector(9).assignUser(galaxy.getUser(5));

  // Energy
  planet.getZone( 2, 1).assignEnergy([ [ galaxy.getUser(5), 75 ] ]);
  planet.getZone( 3, 1).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 2, 2).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 3, 2).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 2, 3).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 3, 3).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 3, 4).assignEnergy([ [ galaxy.getUser(5), 80 ] ]);

  planet.getZone( 4, 0).assignEnergy([ [ galaxy.getUser(5), 70 ] ]);
  planet.getZone( 6, 0).assignEnergy([ [ galaxy.getUser(5), 70 ] ]);
  planet.getZone( 4, 1).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 5, 0).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 5, 1).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 6, 1).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 4, 2).assignEnergy([ [ galaxy.getUser(5), 95 ] ]);
  planet.getZone( 5, 2).assignEnergy([ [ galaxy.getUser(5), 95 ] ]);
  planet.getZone( 6, 2).assignEnergy([ [ galaxy.getUser(5), 95 ] ]);

  planet.getZone( 6, 3).assignEnergy([ [ galaxy.getUser(5), 60 ] ]);
  planet.getZone( 7, 1).assignEnergy([ [ galaxy.getUser(5), 35 ] ]);
  planet.getZone( 7, 2).assignEnergy([ [ galaxy.getUser(5), 65 ] ]);
  planet.getZone( 8, 2).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);
  planet.getZone( 7, 3).assignEnergy([ [ galaxy.getUser(5), 75 ] ]);

  planet.getZone( 4, 3).assignEnergy([ [ galaxy.getUser(5),100 ] ]);
  planet.getZone( 5, 3).assignEnergy([ [ galaxy.getUser(5),100 ] ]);
  planet.getZone( 4, 4).assignEnergy([ [ galaxy.getUser(5), 90 ] ]);
  planet.getZone( 5, 4).assignEnergy([ [ galaxy.getUser(5), 90 ] ]);
  planet.getZone( 6, 4).assignEnergy([ [ galaxy.getUser(5), 90 ] ]);
  planet.getZone( 4, 5).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 5, 5).assignEnergy([ [ galaxy.getUser(5), 90 ] ]);
  planet.getZone( 5, 6).assignEnergy([ [ galaxy.getUser(5), 60 ] ]);
  planet.getZone( 6, 6).assignEnergy([ [ galaxy.getUser(5), 60 ] ]);
  planet.getZone( 6, 5).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);
  planet.getZone( 7, 4).assignEnergy([ [ galaxy.getUser(5), 60 ] ]);

  planet.getZone( 7, 6).assignEnergy([ [ galaxy.getUser(5), 85 ] ]);
  planet.getZone( 6, 7).assignEnergy([ [ galaxy.getUser(5), 80 ] ]);
  planet.getZone( 7, 7).assignEnergy([ [ galaxy.getUser(5), 60 ] ]);
  planet.getZone( 8, 7).assignEnergy([ [ galaxy.getUser(5), 60 ] ]);
  planet.getZone( 7, 8).assignEnergy([ [ galaxy.getUser(5), 60 ] ]);
  planet.getZone( 8, 8).assignEnergy([ [ galaxy.getUser(5), 65 ] ]);
  planet.getZone( 7, 9).assignEnergy([ [ galaxy.getUser(5), 60 ] ]);

  planet.getZone( 8, 3).assignEnergy([ [ galaxy.getUser(5), 75 ] ]);
  planet.getZone( 9, 3).assignEnergy([ [ galaxy.getUser(5), 35 ] ]);
  planet.getZone( 8, 4).assignEnergy([ [ galaxy.getUser(5), 75 ] ]);
  planet.getZone( 9, 4).assignEnergy([ [ galaxy.getUser(5), 35 ] ]);
  planet.getZone( 7, 5).assignEnergy([ [ galaxy.getUser(5), 65 ] ]);
  planet.getZone( 8, 5).assignEnergy([ [ galaxy.getUser(5), 65 ] ]);
  planet.getZone( 9, 5).assignEnergy([ [ galaxy.getUser(5), 50 ] ]);
  planet.getZone( 8, 6).assignEnergy([ [ galaxy.getUser(5), 65 ] ]);
  planet.getZone( 9, 6).assignEnergy([ [ galaxy.getUser(5), 50 ] ]);

  planet.getZone( 6, 9).assignEnergy([ [ galaxy.getUser(5), 10 ] ]);
  planet.getZone( 7,10).assignEnergy([ [ galaxy.getUser(5), 75 ] ]);
  planet.getZone( 6,11).assignEnergy([ [ galaxy.getUser(5), 75 ] ]);
  planet.getZone( 7,11).assignEnergy([ [ galaxy.getUser(5), 75 ] ]);
  planet.getZone( 6,10).assignEnergy([ [ galaxy.getUser(5), 50 ] ]);
  planet.getZone( 8,10).assignEnergy([ [ galaxy.getUser(5), 25 ] ]);
  planet.getZone( 5,11).assignEnergy([ [ galaxy.getUser(5), 10 ] ]);

  planet.getZone( 5, 7).assignEnergy([ [ galaxy.getUser(5),  5 ] ]);
  planet.getZone( 4, 8).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);
  planet.getZone( 5, 8).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);
  planet.getZone( 6, 8).assignEnergy([ [ galaxy.getUser(5),  5 ] ]);
  planet.getZone( 3, 9).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);
  planet.getZone( 4, 9).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);
  planet.getZone( 5, 9).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);
  planet.getZone( 4,10).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);
  planet.getZone( 5,10).assignEnergy([ [ galaxy.getUser(5), 55 ] ]);

  // Buildings
  planet.createBuilding([ 5, 2 ], BuildingEnum.DistributionCenter);
  planet.createBuilding([ 3, 3 ], BuildingEnum.GaussArtillery);
  planet.createBuilding([ 5, 5 ], BuildingEnum.GaussArtillery);
  planet.createBuilding([ 7, 1 ], BuildingEnum.Spaceport);
  planet.createBuilding([ 8, 8 ], BuildingEnum.Spaceport);
  planet.createBuilding([ 8, 5 ], BuildingEnum.GaussArtillery);
  planet.createBuilding([ 4, 9 ], BuildingEnum.GaussArtillery).setStatus('create');

  // Interactions
  //galaxy.createTransferInteraction(planet.getZone(3, 3), planet.getZone(5, 5), { type: ShapeEnum.Sector, variant: 0 });
  //galaxy.createTransferInteraction(planet.getZone(5, 2), planet.getZone(5, 5), { type: ShapeEnum.Sector, variant: 0 });
  //galaxy.createTransferInteraction(planet.getZone(7, 1), planet.getZone(8, 3), { type: ShapeEnum.Sector, variant: 0 });
  //galaxy.createTransferInteraction(planet.getZone(8, 3), planet.getZone(8, 8), { type: ShapeEnum.Sector, variant: 0 });
  //galaxy.createTransferInteraction(planet.getZone(8, 8), planet.getZone(5, 7), { type: ShapeEnum.Sector, variant: 0 });
}


const setupPlanetFive = (galaxy) =>
{
  const planet = galaxy.getPlanet(4);

  // Energy
  planet.getZone( 2, 7).assignEnergy([ [ galaxy.getUser(0), 61 ], [ galaxy.getUser(5), 39 ] ]);
  planet.getZone( 3, 7).assignEnergy([ [ galaxy.getUser(0), 84 ], [ galaxy.getUser(5), 16 ] ]);
  planet.getZone( 2, 8).assignEnergy([ [ galaxy.getUser(0), 84 ], [ galaxy.getUser(5), 16 ] ]);
  planet.getZone( 3, 8).assignEnergy([ [ galaxy.getUser(0), 61 ], [ galaxy.getUser(5), 39 ] ]);
  planet.getZone( 2, 9).assignEnergy([ [ galaxy.getUser(0), 61 ], [ galaxy.getUser(5), 39 ] ]);
  planet.getZone( 3, 9).assignEnergy([ [ galaxy.getUser(0), 61 ], [ galaxy.getUser(5), 39 ] ]);

  planet.getZone( 4, 8).assignEnergy([ [ galaxy.getUser(0), 84 ], [ galaxy.getUser(5), 16 ] ]);

  // Spaceships
  const spaceships =
  [
    galaxy.createSpaceship([  1,17 ], SpaceshipEnum.FighterBasic, galaxy.getUser(5)),
    galaxy.createSpaceship([  0,18 ], SpaceshipEnum.FighterBasic, galaxy.getUser(5)),
    galaxy.createSpaceship([  0,19 ], SpaceshipEnum.FighterBasic, galaxy.getUser(5)),
    galaxy.createSpaceship([ -1,19 ], SpaceshipEnum.FighterBasic, galaxy.getUser(5)),
  ];

  for (const spaceship of spaceships)
  {
    spaceship.setStatus('attack');
  }

  spaceships[0].setTarget(planet.getZone( 2, 7));
  spaceships[1].setTarget(planet.getZone( 3, 8));
  spaceships[2].setTarget(planet.getZone( 2, 9));
  spaceships[3].setTarget(planet.getZone( 3, 9));

  // Interactions
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, spaceships[0], planet.getZone( 2, 7), { type: ShapeEnum.Single, variant: 0 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, spaceships[1], planet.getZone( 3, 8), { type: ShapeEnum.Single, variant: 0 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, spaceships[2], planet.getZone( 2, 9), { type: ShapeEnum.Single, variant: 0 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, spaceships[3], planet.getZone( 3, 9), { type: ShapeEnum.Single, variant: 0 }, { value: Influence.fromPercentage(6)});
}



const setupInterplanetaryInteractions = (galaxy) =>
{
  const planetOne = galaxy.getPlanet(0);
  const planetTwo = galaxy.getPlanet(1);
  const planetFour = galaxy.getPlanet(3);
  const planetFive = galaxy.getPlanet(4);

  // Spaceships
  const spaceshipOne = galaxy.createSpaceship([ -4, -4 ], SpaceshipEnum.FighterBasic, galaxy.getUser(1));
  const spaceshipTwo = galaxy.createSpaceship([-11, -5 ], SpaceshipEnum.FighterBasic, galaxy.getUser(1));

  spaceshipOne.setStatus('attack');
  spaceshipTwo.setStatus('attack');

  spaceshipOne.setTarget(planetTwo.getZone( 2, 8))
  spaceshipTwo.setTarget(planetTwo.getZone( 1, 8))

  // Interactions
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, spaceshipOne, planetTwo.getZone( 2, 8), { type: ShapeEnum.Single, variant: 0 }, { value: Influence.fromPercentage(6)});
  galaxy.createInteraction(InteractionEnum.IncreaseInfluence, spaceshipTwo, planetTwo.getZone( 1, 8), { type: ShapeEnum.Single, variant: 0 }, { value: Influence.fromPercentage(6)});

  // Projectiles
  galaxy.createProjectile(ProjectileEnum.LaserBattery, planetTwo.getZone( 9, 5), spaceshipOne, { type: ShapeEnum.TripleArea, variant: 0 }, 150, 900);
  galaxy.createProjectile(ProjectileEnum.GaussCannon, planetTwo.getZone(12, 2), spaceshipOne, { type: ShapeEnum.QuadrupleArea, variant: 0 }, 600, 900);

  galaxy.createProjectile(ProjectileEnum.GaussArtillery, planetFour.getZone( 3, 3), planetFive.getZone(3, 8), { type: ShapeEnum.SeptupleArea, variant: 0 }, 200, 900);
  galaxy.createProjectile(ProjectileEnum.GaussArtillery, planetFour.getZone( 5, 5), planetFive.getZone(3, 8), { type: ShapeEnum.SeptupleArea, variant: 0 }, 250, 900);
  galaxy.createProjectile(ProjectileEnum.GaussArtillery, planetFour.getZone( 8, 5), planetFive.getZone(3, 8), { type: ShapeEnum.SeptupleArea, variant: 0 }, 300, 900);
}
